import type {
  CountdownWidgetModel,
  HonourRollWidgetModel,
  ImageWidgetModel,
  ItemTableWidgetModel,
  NotificationWidgetModel,
  QrCodeWidgetModel,
  RaffleDrawWidgetModel,
  RaffleWinnersWidgetModel,
  SmartTextWidgetModel,
  TeamScoringWidgetModel,
  PowerPledgeWidgetModel,
  TextWidgetModel,
  ThermometerWidgetModel,
  TotalRaisedWidgetModel,
  VideoWidgetModel,
} from 'libs/gb-dashboard/presenter/data-access-presenter-widgets/src/lib/+state/presenter-widgets.models'

export interface ProjectorContainer {
  uuid: string
  name: string
  aspect_ratio: string
  is_active: boolean
  created: string
  auction: string
  template_uuid?: string | null
}

export interface ProjectorContainerWidgetsResponse {
  CountDownProjectorWidget?: CountdownWidgetModel[]
  ImageProjectorWidget?: ImageWidgetModel[]
  TextProjectorWidget?: TextWidgetModel[]
  SmartTextProjectorWidget?: SmartTextWidgetModel[]
  TotalRaisedProjectorWidget?: TotalRaisedWidgetModel[]
  TeamScoringProjectorWidget?: TeamScoringWidgetModel[]
  PowerPledgeProjectorWidget?: PowerPledgeWidgetModel[]
  NotificationProjectorWidget?: NotificationWidgetModel[]
  ItemTableProjectorWidget?: ItemTableWidgetModel[]
  RaffleWinnersProjectorWidget?: RaffleWinnersWidgetModel[]
  HonourRollProjectorWidget?: HonourRollWidgetModel[]
  ThermometerProjectorWidget?: ThermometerWidgetModel[]
  RaffleDrawProjectorWidget?: RaffleDrawWidgetModel[]
  QrCodeProjectorWidget?: QrCodeWidgetModel[]
  VideoProjectorWidget?: VideoWidgetModel[]
}

export const PROJECTOR_CONTAINERS_LOADER = {
  duplicateSlide: {
    id: 'duplicateSlideProjectorContainer',
  },
  deleteProjectorContainer: {
    id: 'deleteProjectorContainer',
  },
}
